// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".similar-titles[data-v-d1ddcfd0]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
